import React from 'react';
import posed, { PoseGroup } from 'react-pose';

import Skeleton from '../../../modules/skeleton';
import OrdersItem from '../orders-item/orders-item';
import { OrdersItemProps } from '../types';

import './orders-list.scss';

interface OrdersListProps {
  data: OrdersItemProps[];
  onItemClick: (id: number) => void;
  loading: boolean;
  count: number;
}

const AnimateUlItem = posed.li({
  enter: {
    opacity: 1,
    transition: {
      opacity: {
        ease: 'linear',
        duration: 300,
        delay: 300,
      },
    },
  },
  exit: { opacity: 0 },
});

const OrdersList: React.FC<OrdersListProps> = ({
  data,
  onItemClick,
  loading,
  count,
}) => (
  <ul className="orders__list">
    {loading ? (
      <PoseGroup flipMove={false}>
        {new Array(count).fill({}).map((_el, index) => (
          <AnimateUlItem
            key={index}
            className="orders__item"
            onClick={() => onItemClick(index)}
          >
            <Skeleton
              variant="rect"
              height={64}
              width="100%"
              key={`skelet-${index}`}
              className="orders__item order-item"
            />
          </AnimateUlItem>
        ))}
      </PoseGroup>
    ) : (
      <>
        {data.length ? (
          <PoseGroup flipMove={false}>
            {data.map((item) => (
              <AnimateUlItem
                key={item.id}
                className="orders__item"
                onClick={() => onItemClick(item.id)}
              >
                <OrdersItem {...item} />
              </AnimateUlItem>
            ))}
          </PoseGroup>
        ) : (
          <div className="table__empty">Данных пока нет</div>
        )}
      </>
    )}
  </ul>
);

export default OrdersList;
